import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_docuflow-68/artifacts/y7jajers_Well%20Connected%20Logo_Feb2024_600px.jpg";

export function BrandedFooter({ variant = "default" }) {
  const isLight = variant === "light";
  
  return (
    <footer className={`py-6 mt-auto ${isLight ? "bg-transparent" : "bg-slate-50 border-t"}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="WELL Connected" className="h-8" />
            <div className="h-6 w-px bg-slate-300" />
            <span className={`text-sm font-medium ${isLight ? "text-slate-600" : "text-[#E01626]"}`}>
              THE SMART PRINTER PEOPLE
            </span>
          </div>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <span>Print • Copy • Scan • Process • Smart Print</span>
          </div>
          <div className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} WELL Connected Business Systems
          </div>
        </div>
      </div>
    </footer>
  );
}

export default BrandedFooter;
